export default __webpack_public_path__ + "static/media/digestibility-icon.2c5b057c.svg";